export const matchTestLink = (type: any) => {
    switch (type) {
        case "MCAT":
            return "https://www.princetonreview.com/legal/guarantee-better-scores?preview=1&version=101#!Test-MCAT";
        case "SAT":
            return "https://www.princetonreview.com/legal/guarantee-better-scores?preview=1&version=101#!Test-SAT";
        case "ACT":
            return "https://www.princetonreview.com/legal/guarantee-better-scores?preview=1&version=101#!Test-ACT";
        case "GRE":
            return "https://www.princetonreview.com/legal/guarantee-better-scores?preview=1&version=101#!Test-GRE";
        case "GMAT":
            return "https://www.princetonreview.com/legal/guarantee-better-scores?preview=1&version=101#!Test-GMAT";
        case "LSAT":
            return "https://www.princetonreview.com/legal/guarantee-better-scores?preview=1&version=101#!Test-LSAT";
        case "DAT":
            return "https://www.princetonreview.com/legal/guarantee-better-scores?preview=1&version=101#!Test-DAT";
        case "OAT":
            return "https://www.princetonreview.com/legal/guarantee-better-scores?preview=1&version=101#!Test-OAT";
        case "CFA":
            return "https://www.princetonreview.com/legal/guarantee-better-scores?preview=1&version=101#!Test-CFA";
        default:
            break;
    }
}